export const ADD = 'app/EditSessionPage/Single/ADD';
export const UPDATE_ANSWER = 'app/EditSessionPage/Single/UPDATE';
export const UPDATE_VARIABLE = 'app/EditSessionPage/Single/UPDATE_VARIABLE';
export const REMOVE = 'app/EditSessionPage/Single/REMOVE';
export const REORDER = 'app/EditSessionPage/Single/REORDER';
